export const DOCUMENT_TYPE_FAQ_FRONTPAGE = 'faq-frontpage';
